import styled from 'styled-components';

const StyledBaseButton = styled.button.attrs(({type}) => ({
    type: type || 'button',
}))`
    cursor: pointer;

    &:disabled {
        cursor: wait;
    }
`;

export {StyledBaseButton as BaseButton};
